import React      from "react";

import InfoImg   from 'images/products/project_quote/Info.svg'

const ProjectBanner = () => {
  return (
    <div className="project-banner">
      <div className="container">
        <div className="row">
          <div className="col-12 banner-section">
            <p>
              <strong>PROJECT SUMMARY</strong>
              &nbsp;&nbsp;
              <img src={InfoImg}/>
              &nbsp;
              <span>
                You can get a PCB Assembly and PCB Fabrication Online Quote 
                in the same quote! Please fill both or one forms to get one.
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectBanner;